export const API_URL = `https://opentdb.com/api.php?`;
export const QUES_PER_PAGE = 1;